import { BaseEntity } from "yt-ng-framework";

export class OrgJedDefginiView extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string;
    Vrednost: string;
    Tip: string;
    Opis: string;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.Vrednost = input.Vrednost;
        this.Tip = input.Tip;
        this.Opis = input.Opis; 
        return this;
    }

    Serialize(input: OrgJedDefginiView) {
        return input;
    }

} 